export const fieldInputClass =
  'w-full rounded-[10px] border-[1.5px] border-[var(--line)] bg-white px-[15px] py-[13px] font-[inherit] text-[15px] text-[var(--ink)] transition-colors duration-150 focus:border-[var(--ink-blue)] focus:outline-none'

export default function Field({ label, htmlFor, children }) {
  return (
    <div className="mt-[18px]">
      <label htmlFor={htmlFor} className="mb-2 block font-mono text-[11.5px] tracking-[0.05em] text-[var(--faint)] uppercase">{label}</label>
      {children}
    </div>
  )
}
